import {useMemo} from "react";
import {BasicTable} from "components/Table";

function formatCurrency(value) {
	return new Intl.NumberFormat("id-ID", {
		style: "currency",
		currency: "IDR",
		maximumFractionDigits: 0,
	}).format(Number(value) || 0);
}

export function InvoiceTable({
	data = [],
	loading = false,
	currentPage = 1,
	limit = 10,
	totalItems = 0,
	totalPages = 0,
	onPageChange,
	onLimitChange,
	onEdit,
}) {
	const columns = useMemo(
		() => [
			{
				Header: "No",
				accessor: "idSerial",
			},
			{
				Header: "Invoice No",
				accessor: "invoiceNumber",
			},
			{
				Header: "Tanggal",
				accessor: "date",
			},
			{
				Header: "Pasien",
				accessor: "patientName",
			},
			{
				Header: "Rumah Sakit",
				accessor: "hospitalName",
			},
			{
				Header: "Status Pembayaran",
				accessor: "paymentStatus",
			},
			{
				Header: "Total",
				accessor: "totalPrice",
				Cell: ({row}) => formatCurrency(row?.original?.totalPrice),
			},
			{
				Header: "Action",
				accessor: "id",
				Cell: ({row}) => (
					<button className="btn btn-orange" type="button" onClick={() => onEdit(row?.original)}>
						Edit
					</button>
				),
			},
		],
		[onEdit],
	);

	return (
		<BasicTable
			columns={columns}
			currentPage={currentPage}
			data={data}
			limit={limit}
			loading={loading}
			totalItems={totalItems}
			totalPage={totalPages}
			onLimitChange={onLimitChange}
			onPageChange={onPageChange}
		/>
	);
}
